import config from "./config"
export default {
  Index: function(to) {
    return (window.location.href = config.PHPHOST)
  },
  prodetail: function(to) {
    return (window.location.href = config.PHPHOST + "sjk/" + to.query.id)
  },
  formula: function(to) {
    return (window.location.href =
      config.PHPHOST + "formula/details/" + to.query.formula_id)
  },
  searchresult: function(to) {
    let keyword = to.query.keyword
    if (typeof keyword === "undefined") keyword = ""
    const level1 = to.query.level1,
      level2 = to.query.level2
    if (level1) {
      const obj = {
        productCate: [[]]
      }
      if (level2) {
        obj.productCate[0].push(level1 + "-" + level2 + "-0")
        obj.productCate[0].push(to.query.name)
        obj.productCate[0].push(level2)
        obj.productCate[0].push(1)
      } else {
        obj.productCate[0].push(level1 + "-0-0")
        obj.productCate[0].push(to.query.name)
        obj.productCate[0].push(level1)
        obj.productCate[0].push(0)
      }
      return (window.location.href =
        config.PHPHOST +
        "new/sjk?search_name=" +
        keyword +
        "&search_type=1&params=" +
        encodeURIComponent(JSON.stringify(obj)))
    }
    return (window.location.href =
      config.PHPHOST + "new/sjk?search_name=" + keyword + "&search_type=1")
  },
  companyDetails: function(to) {
    return (window.location.href =
      config.PHPHOST + "qiye/" + to.query.companyId)
  }
}



// WEBPACK FOOTER //
// ./src/common/platform.js